import React, { useContext, useEffect } from 'react';
import { useAtom, atom } from 'jotai';
import {
    highCostAtomUserSettings,
    highCostAlertsAtomUserSettings,
    clarificationsAtomUserSettings,
    priorAuthAtomUserSettings,
    nonCoveredAtomUserSettings,
    therapeuticIntAtomUserSettings,
    admissionMedsAtomUserSettings,
    refillTooSoonAtomUserSettings,
    pumpPickupAtomUserSettings,
    narcoticsRefillAtomUserSettings,
    alfNewScriptAtomUserSettings,
    alfCostResponseAtomUserSettings
} from '../jotai-atoms/AlertAtoms';
import { UserContext } from '../contexts/UserContext';

const useAlertsUserSettings = () => {
    const { user } = useContext(UserContext);
    const [highCostUserSettings, setHighCostUserSettings] = useAtom(highCostAtomUserSettings);
    const [highCostAlertsUserSettings, setHighCostAlertsUserSettings] = useAtom(highCostAlertsAtomUserSettings);
    const [nonCoveredUserSettings, setNonCoveredUserSettings] = useAtom(nonCoveredAtomUserSettings);
    const [clarificationsUserSettings, setClarificationsUserSettings] = useAtom(clarificationsAtomUserSettings);
    const [priorAuthUserSettings, setPriorAuthUserSettings] = useAtom(priorAuthAtomUserSettings);
    const [therapeuticIntUserSettings, setTherapeuticIntUserSettings] = useAtom(therapeuticIntAtomUserSettings);
    const [admissionMedsUserSettings, setAdmissionMedsUserSettings] = useAtom(admissionMedsAtomUserSettings);
    const [refillTooSoonSettings, setRefillTooSoonSettings] = useAtom(refillTooSoonAtomUserSettings);
    const [pumpPickupSettings, setPumpPickupSettings] = useAtom(pumpPickupAtomUserSettings);
    const [narcoticsRefillSettings, setNarcoticsRefillSettings] = useAtom(narcoticsRefillAtomUserSettings);
    const [alfNewScriptSettings, setAlfNewScriptSettings] = useAtom(alfNewScriptAtomUserSettings);
    const [alfCostResponseSettings, setAlfCostResponseSettings] = useAtom(alfCostResponseAtomUserSettings);

    const getRequests = [
        {
            path: 'highCost',
            stateName: 'highCost',
            setter: setHighCostUserSettings,
            getter: highCostUserSettings
        },
        {
            path: 'highcostalerts',
            stateName: 'highCostAlerts',
            setter: setHighCostAlertsUserSettings,
            getter: highCostAlertsUserSettings
        },
        {
            path: 'openbatch',
            stateName: 'openBatch',
            setter: setClarificationsUserSettings,
            getter: clarificationsUserSettings
        },
        {
            path: 'nonCovered',
            stateName: 'nonCovered',
            setter: setNonCoveredUserSettings,
            getter: nonCoveredUserSettings
        },
        {
            path: 'priorAuth',
            stateName: 'priorAuth',
            setter: setPriorAuthUserSettings,
            getter: priorAuthUserSettings
        },
        {
            path: 'therapeuticint',
            stateName: 'theraInt',
            setter: setTherapeuticIntUserSettings,
            getter: therapeuticIntUserSettings
        },
        {
            path: 'admissionmeds',
            stateName: 'admissionMeds',
            setter: setAdmissionMedsUserSettings,
            getter: admissionMedsUserSettings
        },
        {
            path: 'refilltoosoon',
            stateName: 'refillTooSoon',
            setter: setRefillTooSoonSettings,
            getter: refillTooSoonSettings
        },
        {
            path: 'pumpPickup',
            stateName: 'pumpPickup',
            setter: setPumpPickupSettings,
            getter: pumpPickupSettings
        },
        {
            path: 'narcoticsRefill',
            stateName: 'narcoticsRefill',
            setter: setNarcoticsRefillSettings,
            getter: narcoticsRefillSettings
        },
        {
            path: 'alfNewScript',
            stateName: 'alfNewScript',
            setter: setAlfNewScriptSettings,
            getter: alfNewScriptSettings
        },
        {
            path: 'alfCostResponse',
            stateName: 'alfCostResponse',
            setter: setAlfCostResponseSettings,
            getter: alfCostResponseSettings
        },
    ]

    const setSortOrder = async ({ path, getter, setter, stateName }) => {
        if (!user.userSettings) {
            setter({ sortOrder: 0, hidden: true })
            return
        }
        let sort = `widget_${stateName}_SortOrder`
        let hidden = `widget_${stateName}_Show`
        // Default to visible: only an explicit 'false' (the user turned it off themselves) hides it.
        // A missing key - e.g. a widget added after this user's settings were first saved - stays visible.
        setter({ sortOrder: Number(user.userSettings[sort]), hidden: user.userSettings[hidden] === 'false' })
    }

    useEffect(() => {
        if (user) {
            getRequests.forEach((req) => {
                setSortOrder(req)
            })
        }
    }, [user])

}

export default useAlertsUserSettings;